/* Установщик «Аватар»: объект в window на том месте порядка скриптов, где стоял assets/bot-avatar.js.
   В серверном режиме движок шаблона получает сервер экрана (avatar-server.ts) и экран avatar встаёт в реестр движков студии;
   выбирает его только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createAvatar } from './engine';
import { createAvatarServer, registerAvatarEngine } from './avatar-server';

export function installAvatar() {
  const server = isServerMode();
  createAvatar(server ? createAvatarServer : null);
  if (server) registerAvatarEngine();
}
